export default {
    _prefix: "questionComponents.common",
    labels: {
        textArea: "Add Response",
        readOnlyTextArea: "Free Text Response",
        error: (data: { total: number }) =>
            "Response must be less than {{total}} characters",
    },
};
